(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/analytics/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/analytics/assets/javascripts/constants.js');
"use strict";


const oddsetTrackingLabel = 'oddset';
setGlobal('svs.oddset_kambi.components.analytics.constants', {
  oddsetTrackingLabel
});

 })(window);